import { Link } from "react-router-dom";

interface Props {}

const NotFoundPage = ({}: Props) => {

  return (
    <>
      <title>Banana Not Found 404 | Tuttobanana</title>
      <meta name="description" content="404: This banana doesn't exist." />
      <div className="bg-gray-100 text-gray-900 min-h-screen px-6 py-20 sm:px-12">
        <div className="flex flex-col items-center text-center">
          <h1 className="text-4xl font-extrabold text-gray-900 mb-6">
            404: Banana Not Found
          </h1>
          <img
            src={`/logos/bananas/not-found.png`}
            alt="Banana not found"
            className="w-64 h-auto mb-8"
          />
          <Link
            to="/"
            className="inline-block rounded-lg bg-yellow-400 px-6 py-3 font-semibold text-gray-900 shadow hover:bg-yellow-300 transition"
          >
            Go back home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
